import starRating from './StarRating';
import ShowMoreButton from './ShowMoreButton';

// app/views/shared/rich_shop_list.html.slimを有効化させる
export default () => {
  starRating();
  const showMoreButton = new ShowMoreButton('.ShowMoreButton', '.c-button_wrapper');
  showMoreButton.addEvent();
};
